import UserTagsManagementView from './UserTagsManagementView';
import UserTagsEditor from './UserTagsEditor';
import UserTagsDetail from './UserTagsDetail';
import BasicTagsView from './BasicTagsView'
import UserQueryingView from './UserQueryingView'
import UserClusteringView from './UserClusteringView'
import auth from '../Service/AuthFetchService';

import { Layout, Menu, Button } from 'antd';
import { MenuOutlined, HomeOutlined, IdcardOutlined, LineChartOutlined, TagsOutlined } from '@ant-design/icons';
import { BrowserRouter as Router, Link, Route, Redirect, Switch } from 'react-router-dom';
import React from 'react';

const { Content, Sider } = Layout;

class UserProfileView extends React.Component {
    constructor() {
        super();

        const path = window.location.pathname;
        let view = 'UserTagsManagementView';
        if (path.startsWith('/user_profile/basic/tags')) {
            view = 'BasicTagsView';
        } else if (path.startsWith('/user_profile/users')) {
            view = 'UserQueryingView';
        } else if (path.startsWith('/user_profile/clustering')) {
            view = 'UserClusteringView';
        } else if (path.startsWith('/user_profile/user_tags')) {
            view = 'UserTagsManagementView';
        }
        this.state = {
            collapsed: false,
            currentView: view
        }
    }

    collapseSider() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    render() {
        return (
            <Router basename="/user_profile">
                <Layout className="site-layout-background" style={{ padding: '10px 0' }} hidden={this.props.hidden} >
                    <Sider className="site-layout-background" width={200} theme={"light"} collapsed={this.state.collapsed}>
                        <Menu
                            mode="inline"
                            selectedKeys={[this.state.currentView]}
                            defaultSelectedKeys={[this.state.currentView]}
                            defaultOpenKeys={['TagsManagement']}
                            onSelect={(item) => {
                                this.setState({ currentView: item.key })
                            }}
                            style={{ height: '100%' }}
                        >
                            <Button size="middle" icon={<MenuOutlined />} onClick={(e) => this.collapseSider()}
                                style={{
                                    color: "#000000",
                                    border: "none",
                                    margin: "0px 0px 0px 15px"
                                }}
                            />
                            {auth.allow('datap:user_profile:tags:management') &&
                                <Menu.Item icon={<TagsOutlined />} key="UserTagsManagementView">
                                    <Link to="/user_tags">用户标签</Link>
                                </Menu.Item>}
                            {auth.allow('datap:user_profile:clustering') &&
                                <Menu.Item icon={<LineChartOutlined />} key="UserClusteringView">
                                    <Link to="/clustering">用户分群</Link>
                                </Menu.Item>}
                            {auth.allow('datap:user_profile:querying') &&
                                <Menu.Item icon={<IdcardOutlined />} key="UserQueryingView">
                                    <Link to="/users">个体洞察</Link>
                                </Menu.Item>}
                        </Menu>
                    </Sider>
                    <Content justify="space-around" align="middle" style={{ padding: '0 10px', overflow: 'hidden' }}>
                        <Switch>
                            {auth.allow('datap:user_profile:tags:management') &&
                                <Route path="/" exact render={() => <Redirect to="/user_tags" />} />}
                            {auth.allow('datap:user_profile:tags:management') &&
                                <Route path="/user_tags" exact component={UserTagsManagementView} />}
                            {auth.allow('datap:user_profile:tags:management') &&
                                <Route path="/user_tags/new" exact component={UserTagsEditor} />}
                            {auth.allow('datap:user_profile:tags:management') &&
                                <Route path="/user_tags/edit/:id" exact render={history => <UserTagsEditor tagId={history.match.params.id} />} />}
                            {auth.allow('datap:user_profile:tags:management') &&
                                <Route path="/user_tags/detail/:id" exact render={history => <UserTagsDetail tagId={history.match.params.id} />} />}
                            {auth.allow('datap:user_profile:querying') &&
                                <Route path="/users" component={UserQueryingView} />}
                            {auth.allow('datap:user_profile:clustering') &&
                                <Route path="/clustering" component={UserClusteringView} />}
                        </Switch>
                    </Content>
                </Layout>
            </Router>
        );
    }
}

export default UserProfileView;